import design from './zh-CN/design';
import menu from './zh-CN/menu';
import mockup from './zh-CN/mockup';
import pages from './zh-CN/pages';

export default {
  'navBar.lang': '语言',
  ...menu,
  ...pages,
  ...mockup,
  ...design,
};
